import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerContrattiDaFornitoreModalComponent} from './worker-contratti-da-fornitore-modal';

export const WorkerContrattiDaFornitoreModalModule: string = ng
    .module('worker-contratti_da_fornitore-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerContrattiDaFornitoreModalComponent', WorkerContrattiDaFornitoreModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-contratti-da-fornitore-modal/worker-contratti-da-fornitore-modal.module.ts